<template>
  <div class="container">
    <header class="jumbotron">
      <h3>TBA</h3>

      
      <!-- {{ content }} -->
      <div class="">
    <h4><a href="/v1/docs/" target="_blank">API Docs</a></h4>
  </div>

  <h4><a href="/testruns"><strong>Test Runs</strong></a><br /></h4>
  <h4><a href="/newtest"><font-awesome-icon icon="fa-solid fa-plus" size="sm" :style="{ color: 'red' }" /> NEW Test Run</a></h4>

  <h4><a href="/mock"><strong>MOCK API</strong></a><br /></h4>

  <!-- <h4><a href="/buildframeworks"><strong>BUILD Studio Headless Framework</strong></a><br /></h4> -->



      <font-awesome-icon icon="bug" bounce size="lg" :style="{ color: 'red' }" /> 

    </header>
  </div>

</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import UserService from "../services/user.service";

export default {
    name: "Home",
    data() {
        return {
            content: "",
        };
    },
    mounted() {
        UserService.getPublicContent().then((response) => {
            this.content = response.data;
        }, (error) => {
            this.content =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                    error.message ||
                    error.toString();
        });
    },
    components: { FontAwesomeIcon }
};
</script>
